import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {jwtDecode} from 'jwt-decode';

const AdminRoute = () => {
  const { token, isAdmin } = useAuth();

  // Check if token exists in localStorage and validate it
  const storedToken = localStorage.getItem('token');
  const storedIsAdmin = localStorage.getItem('isAdmin') === 'true';

  let validToken = false;
  if (storedToken) {
    try {
      const decoded = jwtDecode(storedToken);
      validToken = decoded.exp * 1000 > Date.now(); // Token is valid if not expired
    } catch (err) {
      console.error('Invalid token:', err.message);
    }
  }

  // Final admin check: token must be valid and user must be admin
  const isUserAdmin = validToken && (isAdmin || storedIsAdmin);

  if (!isUserAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
